
// import React, { useState } from "react";

// const ToggleButton = ({class_="", label, onToggle, id = null, value }) => {
//   const [internal, setInternal] = useState(false);
//   const isControlled = value !== undefined;
//   const isActive = isControlled ? value : internal;

//   const handleToggle = () => {
//     const newVal = !isActive;
//     if (!isControlled) setInternal(newVal);
//     onToggle?.(newVal, id);
//   };

//   return (
//     <div className={`toggle-container ${class_}`}>
//       <label className="switch">
//         <input type="checkbox" checked={isActive} onChange={onToggle} />
//         <span className="slider round"></span>
//       </label>

//       <span className="toggle-label" onClick={onToggle}>{label}</span>
//     </div>
//   );
// };

// export default ToggleButton;


import React, { useState } from "react";

const ToggleButton = ({ class_ = "", labelclass_ = "", label, onToggle, id = null, value }) => {
  const [internal, setInternal] = useState(false);
  const isControlled = value !== undefined;
  const isActive = isControlled ? value : internal;

  const handleToggle = () => {
    const newVal = !isActive;
    if (!isControlled) setInternal(newVal);
    onToggle?.(newVal, id);
  };

  return (
    <div className={`toggle-container ${class_}`}>
      <label className="switch">
        <input type="checkbox" checked={isActive} onChange={handleToggle} />
        <span className="slider round"></span>
      </label>

      <span className={`toggle-label ${labelclass_}`} onClick={handleToggle}>{label}</span>
    </div>
  );
};

export default ToggleButton;
